import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./IndEvent.module.css"
import guestii from '../../assets/images/logos/guestii.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'
import { GuestiiTags, GuestiiTypes, GuestiiPlusOnes, GuestiiPromoters } from './EditGuestiiModules'


const InviteGuestii = ({ setSettingTags, handleClose, inviteSearch, setInviteSearch, inviteGuestiisActive, setInviteGuestiisActive, guestiisChecked, setGuestiisChecked, setMainReloadKey, setSettingTypes, settingTypes, setSettingPlusOnes, settingPromoters, setSettingPromoters }) => {
	const param = useParams();
	const [isLoading, setIsLoading] = useState(false)

	function sanitizeString(str) {
	  	return str
	    	.replace(/&/g, "&amp;")
	    	.replace(/</g, "&lt;")
	    	.replace(/>/g, "&gt;")
	    	.replace(/"/g, "&quot;")
	    	.replace(/'/g, "&#39;");
	}

  	const handleGuestiiSearch = async () => {
		setIsLoading(true)

		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}

	  	try {
	  		const raw = (inviteSearch || "").trim();
	  		const cleanSearch = sanitizeString(raw);
			const lines = cleanSearch
				.split(/\r?\n/)
				.map((l) => l.trim())
				.filter((l) => l.length > 0);

	  		const body = {
	  			lines: lines
	  		}

		    const res = await axios.post(`/api/events/check-guestiis/${param.event_id}`, body, {
		      	headers: {
		        	'x-user-id': userId,
		        	'x-expiry': expiry
		      	}
		    });

		    setGuestiisChecked((prev) => {
		    	let previous = [...prev]

		    	res.data.guestiis.forEach((g) => {
		    		if (previous.filter(p => p.guestii === g.guestii).length === 0) {
		    			previous.push(g)
		    		}
		    	})

		    	const newMapped = res.data.guestiis.map(n => n.guestii)
		    	previous = previous.filter(p => newMapped.includes(p.guestii))

		    	return previous
		    })
	  	} catch (err) {
	  		console.log(err)
			// localStorage.removeItem("_id")
			// localStorage.removeItem("expiry")
			// window.location = "/connect"
	  	}

  		setIsLoading(false)
  	};

  	const handleSubmit = async (invite_selected=false) => {
		setIsLoading(true)

		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}


	  	try {
	  		const body = {
	  			guestiis: invite_selected ? guestiisChecked.filter(g => inviteGuestiisActive.includes(g.guestii)) : guestiisChecked
	  		}

		    const res = await axios.post(`/api/events/invite-guestiis/${param.event_id}`, body, {
		      	headers: {
		        	'x-user-id': userId,
		        	'x-expiry': expiry
		      	}
		    });

		    setMainReloadKey((prevKey) => prevKey + 1);
		    handleClose(true)
	  	} catch (err) {
	  		console.log(err)
			// localStorage.removeItem("_id")
			// localStorage.removeItem("expiry")
			// window.location = "/connect"
	  	}

  		setIsLoading(false)
  	}

  	const openBulkPlusOnes = async () => {
		setSettingPlusOnes(inviteGuestiisActive)
  	}

  	const openBulkTags = async () => {
  		const checkForTags = guestiisChecked.filter(g => inviteGuestiisActive.includes(g.guestii) && g.tags && g.tags.length > 0)

  		if (checkForTags.length > 0) {
  			let allSame = true;
  			let currentCheck;

  			checkForTags.map(t => t.tags).forEach((tagArr, i) => {
  				if (i === 0) {
  					currentCheck = JSON.stringify(tagArr);
  					return;
  				} else {
  					if (JSON.stringify(tagArr) !== currentCheck) {
  						allSame = false;
  						return;
  					} else {
  						currentCheck = JSON.stringify(tagArr);
  					}
  				}
  			})

  			if (!allSame) {
  				const confirm = await window.confirm("The tags set for the selected Guestiis are currently NOT the same. If you edit and save, it will override all of the current tags.")
  				if (confirm) {
  					setSettingTags(inviteGuestiisActive)
  				}
  			} else {
  				setSettingTags(inviteGuestiisActive)
  			}
  		} else {
  			setSettingTags(inviteGuestiisActive)
  		}
  	}

  	const openBulkTypes = async () => {
  		const checkForTypes = guestiisChecked.filter(g => settingTypes.includes(g.guestii) && g.type)

  		if (checkForTypes.length > 0) {
  			let allSame = true;
  			let currentCheck;

  			checkForTypes.map(t => t.type).forEach((type, i) => {
  				if (i === 0) {
  					currentCheck = JSON.stringify(type);
  					return;
  				} else {
  					if (JSON.stringify(type) !== currentCheck) {
  						allSame = false;
  						return;
  					} else {
  						currentCheck = JSON.stringify(type);
  					}
  				}
  			})

  			if (!allSame) {
  				const confirm = await window.confirm("The types set for the selected Guestiis are currently NOT the same. If you edit and save, it will override all of the current types.")
  				if (confirm) {
  					setSettingTypes(inviteGuestiisActive)
  				}
  			} else {
  				setSettingTypes(inviteGuestiisActive)
  			}
  		} else {
  			setSettingTypes(inviteGuestiisActive)
  		}
  	}

  	const openBulkPromoter = async () => {
  		const checkForPromoters = guestiisChecked.filter(g => settingPromoters.includes(g.guestii) && `${g.source.first_name} ${g.source.last_name}`)

  		if (checkForPromoters.length > 0) {
  			let allSame = true;
  			let currentCheck;

  			checkForPromoters.map(t => t.promoter).forEach((type, i) => {
  				if (i === 0) {
  					currentCheck = JSON.stringify(promoter);
  					return;
  				} else {
  					if (JSON.stringify(type) !== currentCheck) {
  						allSame = false;
  						return;
  					} else {
  						currentCheck = JSON.stringify(promoter);
  					}
  				}
  			})

  			if (!allSame) {
  				const confirm = await window.confirm("The promoters set for the selected Guestiis are currently NOT the same. If you edit and save, it will override all of the current promoters.")
  				if (confirm) {
  					setSettingPromoters(inviteGuestiisActive)
  				}
  			} else {
  				setSettingPromoters(inviteGuestiisActive)
  			}
  		} else {
  			setSettingPromoters(inviteGuestiisActive)
  		}
  	}

	return (
		<div className={`${styles.popup_container_ind_team}`}>
			<div className={styles.promoters_layout}>
				<button className={styles.ind_close_ind} onClick={() => handleClose()}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

				<div className={styles.new_banner}>
					<div className={styles.new_title}>
						<p className={styles.bold}>Invite Guestiis</p>
						<p className={styles.s1}>Use this module to invite your guestiis!</p>
					</div>

					<div className={styles.banner_progress}>
						<div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
							<i className={`fa-solid fa-envelope ${styles.m1}`}></i>
						</div>
					</div>
				</div>

				<div className={styles.promoters_form_container}>
					{!isLoading
						?
							<>
						        <textarea
					                className={`${styles.s1} ${styles.textareaContainer} ${styles.trueMaxWidth} ${styles.fadeContainer}`}
					                placeholder={`Invite a guestii by full name or phone number`}
					                onChange={(e) => setInviteSearch(e.target.value)}
					                value={inviteSearch}
									// disabled={mainLoading || validationError}
					            ></textarea>

					            {(guestiisChecked.filter(g => g.valid).length > 0) &&
					            	<div className={`${styles.guestiis_checked_actions} ${styles.fadeContainer}`}>
										<button className={`${styles.guestiis_checked_action_btn}`} onClick={() => setInviteGuestiisActive(inviteGuestiisActive.length === guestiisChecked.length ? [] : guestiisChecked.map(g => g.guestii))}>
											<p className={styles.xs3}>{inviteGuestiisActive.length === guestiisChecked.length ? "Deselect" : "Select"} All</p>
										</button>

										{inviteGuestiisActive.length > 0 &&
											<>
												<button className={`${styles.guestiis_checked_action_btn}`} onClick={() => openBulkPlusOnes()}>
													<p className={styles.xs3}>Plus Ones</p>
												</button>

												<button className={`${styles.guestiis_checked_action_btn}`} onClick={() => openBulkTypes()}>
													<p className={styles.xs3}>Ticket Type</p>
												</button>

												<button className={`${styles.guestiis_checked_action_btn}`} onClick={() => openBulkTags()}>
													<p className={styles.xs3}>Tags</p>
												</button>

												<button className={`${styles.guestiis_checked_action_btn}`} onClick={() => openBulkPromoter()}>
													<p className={styles.xs3}>Promoter</p>
												</button>
											</>
										}
									</div>
								}

								<button className={`${styles.check_guestiis_btn} ${styles.fadeContainer}`} onClick={() => handleGuestiiSearch()} disabled={isLoading}>
									<p className={styles.xs3}>Check!</p>
								</button>

								<div
									style={{
										height: '100%',
										maxHeight: '100%',
										overflowY: 'scroll',
										position : 'relative',
										marginTop: '3.5rem'
									}}
								>
									<div
										className={`${styles.table_container_indguestii_double} ${styles.fadeContainer} table_container`}
										style={{ gridTemplateRows: `max-content`, marginTop: '1rem' }}
									>
										{guestiisChecked.map((g, i) => {
											const totalRows = Math.ceil(guestiisChecked.length / 2);
											const currentRow = Math.floor(i / 2) + 1;
											const inLastRow = currentRow === totalRows;

											return (
												<button
													className={`${styles.guestii_invited_container} ${!g.valid && styles.no_pointer}`}
													disabled={!g.valid}
													onClick={() => {
														setInviteGuestiisActive((prev) => {
															if (prev.includes(g.guestii)) {
																return [...prev].filter(p => p !== g.guestii)
															}

															return [...prev, g.guestii]
														})
													}}
												>
													<div className={`${styles.guestii_invited_ind_max} ${!g.valid && styles.invalid_guestii_invite}`}>
														<div className={styles.guestii_inner_split_toggle}>
															{g.valid &&
																<div className={`${styles.guestii_toggle_rounded} ${inviteGuestiisActive.includes(g.guestii) && styles.guestii_toggle_rounded_active}`}>
																	{inviteGuestiisActive.includes(g.guestii) && <i className={`fa-solid fa-check ${styles.xs2}`}></i>}
																</div>
															}

															<div className={styles.guestii_profile_info}>
																<div className={styles.name_container_with_box}>
																	<p className={styles.s1}>{g.guestii}</p>
																	{!g.valid && <p className={styles.xs3}>(Already Invited!)</p>}
																</div>
															</div>
														</div>
													</div>
												</button>
											)
										})}

									</div>
								</div>


								{(guestiisChecked.filter(g => g.valid).length > 0) &&
									<div className={styles.submit_guestiis_btn_container}>
										{inviteGuestiisActive.length > 0 &&
											<button className={`${styles.submit_guestiis_btn}`} onClick={() => handleSubmit(true)}>
												<p className={styles.xs3}>Invite Selected</p>
											</button>
										}

										<button className={`${styles.submit_guestiis_btn}`} onClick={() => handleSubmit()}>
											<p className={styles.xs3}>Invite All</p>
										</button>
									</div>
								}
							</>
						:
					        <div className={styles.loading_text_layout}>
					            <img src={guestii_gif}/>
					        </div>
					}
				</div>
			</div>
		</div>
	)
}


const InviteGuestiiModule = ({ setInvitingGuestii, setMainReloadKey }) => {
	const [inviteSearch, setInviteSearch] = useState("")
	const [guestiisChecked, setGuestiisChecked] = useState([])
	const [inviteGuestiisActive, setInviteGuestiisActive] = useState([])
	const [settingTags, setSettingTags] = useState([])
	const [settingTypes, setSettingTypes] = useState([])
	const [settingPlusOnes, setSettingPlusOnes] = useState([])
	const [settingPromoters, setSettingPromoters] = useState([])


	const handleClose = async (bypass=false) => {
		if (settingTags.length > 0) {
			setSettingTags([])
		} else if (settingTypes.length > 0) {
			setSettingTypes([])
		} else if (settingPlusOnes.length > 0) {
			setSettingPlusOnes([])
		} else if (settingPromoters.length > 0) {
			setSettingPromoters([])
		} else {
			if (guestiisChecked.length > 0 && !bypass) {
				const confirm = await window.confirm("Are you sure you want to discard these Guestii invites?")
				if (confirm) {
					setInvitingGuestii(false)
				}
			} else {
				setInvitingGuestii(false)
			}
		}
	}

	return (
		<>
			{settingTags.length > 0
				?
					<GuestiiTags
						handleClose={handleClose}
						settingTags={settingTags}
						setGuestiisChecked={setGuestiisChecked}
						guestiisChecked={guestiisChecked}
					/>
				: settingTypes.length > 0
				?
					<GuestiiTypes
						handleClose={handleClose}
						settingTypes={settingTypes}
						setGuestiisChecked={setGuestiisChecked}
						guestiisChecked={guestiisChecked}
					/>
				: settingPlusOnes.length > 0
				?
					<GuestiiPlusOnes
						handleClose={handleClose}
						settingPlusOnes={settingPlusOnes}
						setGuestiisChecked={setGuestiisChecked}
						guestiisChecked={guestiisChecked}
					/>
				: settingPromoters.length > 0
				?
					<GuestiiPromoters
						handleClose={handleClose}
						settingPromoters={settingPromoters}
						setGuestiisChecked={setGuestiisChecked}
						guestiisChecked={guestiisChecked}
					/>
				:
					<InviteGuestii
						inviteSearch={inviteSearch}
						setInviteSearch={setInviteSearch}
						inviteGuestiisActive={inviteGuestiisActive}
						setInviteGuestiisActive={setInviteGuestiisActive}
						guestiisChecked={guestiisChecked}
						setGuestiisChecked={setGuestiisChecked}
						setMainReloadKey={setMainReloadKey}
						setSettingTags={setSettingTags}
						handleClose={handleClose}
						setSettingTypes={setSettingTypes}
						settingTypes={settingTypes}
						setSettingPlusOnes={setSettingPlusOnes}
						settingPromoters={settingPromoters}
						setSettingPromoters={setSettingPromoters}
					/>
			}
		</>
	);
};

export default InviteGuestiiModule;